import { createI18n } from 'vue-i18n'

import plLocale from '@/locales/pl'

const STORAGE_KEY = 'printfactory-app-locale'
const DEFAULT_LOCALE = import.meta.env.VITE_APP_I18N_LOCALE || 'pl'
const FALLBACK_LOCALE = import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'pl'

const getInitialLocale = () => {
    if (typeof localStorage === 'undefined') return DEFAULT_LOCALE
    return localStorage.getItem(STORAGE_KEY) || DEFAULT_LOCALE
}

export const i18n = createI18n({
    legacy: false,
    locale: getInitialLocale(),
    fallbackLocale: FALLBACK_LOCALE,
    messages: {
        pl: plLocale.messages
    }
})

export const t = (...args) => i18n.global.t(...args)
